const closeBtn = document.querySelector(".header-banner__close")
const banner = document.querySelector(".header-banner")
const isHidden = localStorage.getItem("header-banner");
const main = document.querySelector(".main-page-wrap")
banner.style.maxHeight = banner.scrollHeight + "px";

closeBtn && closeBtn.addEventListener("click", () => {
    banner.classList.add("hidden")
    main && main.classList.remove("with-banner")
    document.cookie = "header_banner=hidden";
    banner.style.maxHeight = 0;
})

const getBannerResize = () => {
    if (!banner.classList.contains("hidden")) {
        banner.style.maxHeight = banner.scrollHeight + "px"
    }
}
closeBtn && window.addEventListener("resize", () => getBannerResize())
setTimeout(() => closeBtn && getBannerResize(), 5)